import React, { useCallback, useEffect, useRef, useState } from 'react';
import { router } from '@inertiajs/react';
import { Search } from 'lucide-react';
import { cn } from '../utils/cn';
export const SearchInput = React.forwardRef(function SearchInput(
  {
    url,
    paramName = 'search',
    defaultValue = '',
    debounce = 300,
    placeholder = 'Search...',
    className,
  },
  ref,
) {
  const [value, setValue] = useState(defaultValue);
  const timerRef = useRef(undefined);
  const performSearch = useCallback(
    (searchValue) => {
      const params = {};
      if (searchValue) {
        params[paramName] = searchValue;
      }
      router.visit(url, {
        data: params,
        preserveState: true,
        preserveScroll: true,
        replace: true,
      });
    },
    [url, paramName],
  );
  const handleChange = useCallback(
    (e) => {
      const newValue = e.target.value;
      setValue(newValue);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => performSearch(newValue), debounce);
    },
    [performSearch, debounce],
  );
  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);
  return (
    <div className={cn('relative', className)}>
      <Search
        size={16}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-fg-tertiary"
        aria-hidden="true"
      />
      <input
        ref={ref}
        type="search"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={cn(
          'w-full rounded-md border border-edge bg-surface py-2 pl-10 pr-3 text-sm',
          'text-fg placeholder:text-fg-tertiary',
          'focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/25',
          'transition-colors duration-150',
        )}
      />
    </div>
  );
});
